/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_Success_TitleInputs */

const en_contact_form_success_title = /** @type {(inputs: Contact_Form_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message sent — thank you`)
};

const lv_contact_form_success_title = /** @type {(inputs: Contact_Form_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziņa nosūtīta — paldies`)
};

/**
* | output |
* | --- |
* | "Message sent — thank you" |
*
* @param {Contact_Form_Success_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_form_success_title = /** @type {((inputs?: Contact_Form_Success_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_Success_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_form_success_title(inputs)
	return en_contact_form_success_title(inputs)
});